import { getData } from "./apiInstance";
import { AxiosResponse } from "axios";
import {
  AgeingAnalysisReportPayloadType,
  BatchSummaryReportPayloadType,
  BatchVoucherReportPayloadType,
  DownloadBatchSummaryReportsType,
  DownloadBatchVoucherReportType,
  DownloadExcelReportsType,
  DownloadExcelStockLimitPayloadType,
  DownloadExcelStockSummaryReportsType,
  DownloadMonthlyLedgerSummaryType,
  GetBalanceSheetPayloadType,
  GetCostOfGoodsPayloadType,
  GetDayBookReportsPayloadType,
  GetDetailedBalanceSheetPayloadType,
  GetDetailedProfitLossStatementPayloadType,
  GetGeneralLedgerPayloadType,
  GetLedgerStatementPdfType,
  GetLedgerStatementType,
  GetMonthlyLedgerSummaryType,
  GetMultipleLedgerStatementPdfType,
  GetProfitLossStatementPayloadType,
  GetReceiptAndPaymentReportsPayloadType,
  GetStockLimitPayloadType,
  GetStockReportsSummaryPayloadType,
  GetStockStatementPayloadType,
  GetTrialBalancePayloadType,
} from "../commonTypes/reportsTypes";

export async function getLedgerStatementApi(
  data: GetLedgerStatementType
): Promise<AxiosResponse> {
  const { client_code, ledger_id, start_date, end_date, token, limit, offset ,branch_id, invoice_type, more_than_value, less_than_value, transaction_type,equal_to_value} =
    data;

  return await getData(`invoice-generation/ledger-statement`, {
    params: {
      client_code,
      ledger_id,
      start_date,
      end_date,
      limit,
      offset,
      ...(branch_id && { branch_id }),
      ...(invoice_type && { invoice_type }),
      less_than_value,
      more_than_value,
      equal_to_value,
      transaction_type




    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getTrialBalanceApi(
  data: GetTrialBalancePayloadType
): Promise<AxiosResponse> {
  const { token, client_code, start_date, end_date } = data;

  return await getData(`invoice-generation/trial-balance`, {
    params: {
      client_code,
      start_date,
      end_date,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getDetailedTrialBalanceApi(
  data: GetTrialBalancePayloadType
): Promise<AxiosResponse> {
  const { token, client_code, start_date, end_date } = data;

  return await getData(`invoice-generation/trial-balance-detailed`, {
    params: {
      client_code,
      start_date,
      end_date,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getProfitLossStatementApi(
  data: GetProfitLossStatementPayloadType
): Promise<AxiosResponse> {
  const { client_code, token, start_date, end_date, branch_id } = data;

  return await getData(`invoice-generation/profit-loss`, {
    params: {
      client_code,
      start_date,
      end_date,
      ...(branch_id && { branch_id }),
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getDetailedProfitLossStatementApi(
  data: GetProfitLossStatementPayloadType
): Promise<AxiosResponse> {
  const { client_code, token, start_date, end_date, branch_id } = data;

  return await getData(`invoice-generation/profit-loss/grouping`, {
    params: {
      client_code,
      start_date,
      end_date,
      ...(branch_id && { branch_id }),
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getDetailedBalanceSheetApi(
  data: GetDetailedBalanceSheetPayloadType
): Promise<AxiosResponse> {
  const { client_code, token, date_value, branch_id } = data;

  return await getData(`invoice-generation/balance-sheet/grouping`, {
    params: {
      client_code,
      date_value,
      ...(branch_id && { branch_id }),
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getBalanceSheetApi(
  data: GetBalanceSheetPayloadType
): Promise<AxiosResponse> {
  const { date_value, token, client_code, branch_id } = data;

  return await getData(`invoice-generation/balance-sheet`, {
    params: {
      date_value,
      client_code,
      ...(branch_id && { branch_id }),
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function downloadReportsApi(
  data: DownloadExcelReportsType
): Promise<AxiosResponse> {
  const { start_date, end_date, ledger_id, client_code, limit, offset, token ,branch_id, invoice_type, more_than_value, less_than_value, transaction_type,equal_to_value} =
    data;

  return await getData(`report-module/ledger-statement/download`, {
    params: {
      start_date,
      end_date,
      ledger_id,
      client_code,
      limit: 100000,
      offset: 0,
      branch_id,
      ...(invoice_type && { invoice_type }),
      less_than_value,
      more_than_value,
      equal_to_value,
      transaction_type
    },
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function downloadTrailBalanceApi(
  data: GetTrialBalancePayloadType
): Promise<AxiosResponse> {
  const { token, client_code, start_date, end_date } = data;

  return await getData(
    `report-module/trial-balance/download
`,
    {
      params: {
        client_code,
        start_date,
        end_date,
        limit: 100000,
        offset: 0,
      },
      responseType: "blob",

      headers: {
        "Content-Type": "application/json",
        "user-token": token,
      },
    }
  );
}
export async function downloadDetailedTrailBalanceApi(
  data: GetTrialBalancePayloadType
): Promise<AxiosResponse> {
  const { token, client_code, start_date, end_date } = data;

  return await getData(
    `invoice-generation/trial-balance-detailed/download
`,
    {
      params: {
        client_code,
        start_date,
        end_date,
        limit: 100000,
        offset: 0,
      },
      responseType: "blob",

      headers: {
        "Content-Type": "application/json",
        "user-token": token,
      },
    }
  );
}

export async function downloadProfitAndLossApi(
  data: GetProfitLossStatementPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, start_date, end_date, branch_id } = data;

  return await getData(`report-module/profit-loss/download`, {
    params: {
      client_code,
      start_date,
      end_date,
      ...(branch_id && { branch_id }),
    },
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function downloadBalanceSheetApi(
  data: GetBalanceSheetPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, date_value, branch_id } = data;

  return await getData(`report-module/balance-sheet/download`, {
    params: {
      client_code,
      date_value,
      ...(branch_id && { branch_id }),
    },
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

// Stock Report
export async function getStockReportsSummaryApi(
  data: GetStockReportsSummaryPayloadType
): Promise<AxiosResponse> {
  const { token, startDate, endDate, client_code ,skuGroup} = data;
  const finalData = {
    start_date: startDate,
    end_date: endDate,
    client_code,
    stock_group_id: skuGroup,

  };
  return await getData(`report-module/sku/summary`, {
    params: finalData,
    headers: {
      "content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function downloadStockSummaryApi(
  data: DownloadExcelStockSummaryReportsType
): Promise<AxiosResponse> {
  const { token, client_code, start_date, end_date,skuGroup } = data;

  return await getData(`report-module/sku/summary/download`, {
    params: {
      client_code,
      start_date,
      end_date,
      stock_group_id: skuGroup,

    },
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
export async function downloadStockStatementApi(
  data: DownloadExcelStockSummaryReportsType
): Promise<AxiosResponse> {
  const { token, client_code, start_date, end_date, sku_id } = data;

  return await getData(`report-module/sku/statement/download`, {
    params: {
      client_code,
      start_date,
      end_date,
      sku_id,
    },
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getStockStatementApi(
  data: GetStockStatementPayloadType
): Promise<AxiosResponse> {
  const { token, startDate, endDate, client_code, skuId } = data;

  const finalData = {
    client_code,
    sku_id: skuId,
    start_date: startDate,
    end_date: endDate,
  };
  return await getData(`report-module/sku/statement`, {
    params: finalData,
    headers: {
      "content-Type": "application/json",
      "user-token": token,
    },
  });
}

// Detailed P&L download
export async function downloadDetailedProfitAndLossApi(
  data: GetProfitLossStatementPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, start_date, end_date, branch_id } = data;

  return await getData(`invoice-generation/profit-loss/grouping/download`, {
    params: {
      client_code,
      start_date,
      end_date,
      ...(branch_id && { branch_id }),
    },
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

// Detailed balanceSheet download
export async function downloadDetailedBalanceSheetApi(
  data: GetBalanceSheetPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, date_value, branch_id } = data;

  return await getData(`invoice-generation/balance-sheet/grouping/download`, {
    params: {
      client_code,
      date_value,
      ...(branch_id && { branch_id }),
    },
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

// Day Book reports
export async function getDayBookReportsApi(
  data: GetDayBookReportsPayloadType
): Promise<AxiosResponse> {
  const { token, clientCode, startDate, endDate } = data;

  return await getData(`invoice-generation/day-book/list`, {
    params: {
      client_code: clientCode,
      start_date: startDate,
      end_date: endDate,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
export async function dayBookReportDownloadApi(
  data: GetDayBookReportsPayloadType
): Promise<AxiosResponse> {
  const { token, clientCode, startDate, endDate } = data;

  return await getData(`invoice-generation/day-book/download`, {
    params: {
      client_code: clientCode,
      start_date: startDate,
      end_date: endDate,
    },
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

//  General Ledger
export async function getGeneralLedgerReportsApi(
  data: GetGeneralLedgerPayloadType
): Promise<AxiosResponse> {
  const { token, clientCode, startDate, endDate } = data;

  return await getData(`invoice-generation/general-ledger`, {
    params: {
      client_code: clientCode,
      start_date: startDate,
      end_date: endDate,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
//  general ledger download
export async function generalLedgerReportDownloadApi(
  data: GetGeneralLedgerPayloadType
): Promise<AxiosResponse> {
  const { token, clientCode, startDate, endDate } = data;

  return await getData(`invoice-generation/general-ledger/download`, {
    params: {
      client_code: clientCode,
      start_date: startDate,
      end_date: endDate,
    },
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getCostOfGoodsApi(
  data: GetCostOfGoodsPayloadType
): Promise<AxiosResponse> {
  const { client_code, token, start_date, end_date } = data;

  return await getData(`report-module/cost-of-goods`, {
    params: {
      client_code,
      start_date,
      end_date,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function downloadCostOfGoodsReportsApi(
  data: GetCostOfGoodsPayloadType
): Promise<AxiosResponse> {
  const { start_date, end_date, token, client_code } = data;

  return await getData(`report-module/cost-of-goods/download`, {
    params: {
      start_date,
      end_date,
      client_code,
    },
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}
export async function getAgeingAnalysisReportApi(
  data: AgeingAnalysisReportPayloadType
): Promise<AxiosResponse> {
  const { client_code, token, type, limit, offset, sort_by, sort_by_value } =
    data;

  return await getData(`report-module/ageing-analysis/report`, {
    params: {
      client_code,
      type,
      limit,
      offset,
      sort_by,
      sort_by_value,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

// ageing analysis report download

export async function downloadAgeingAnalysisReportApi(
  data: AgeingAnalysisReportPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, type, sort_by, sort_by_value } = data;

  return await getData(`report-module/ageing-analysis/report/download`, {
    params: {
      client_code,
      type,
      sort_by,
      sort_by_value,
    },
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getReceiptAndPaymentReportApi(
  data: GetReceiptAndPaymentReportsPayloadType
): Promise<AxiosResponse> {
  const { client_code, token, start_date, end_date } = data;

  return await getData(`report-module/receipt-and-payment/report`, {
    params: {
      client_code,
      start_date,
      end_date,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getLedgerStatementPdfApi(
  data: GetLedgerStatementPdfType
): Promise<AxiosResponse> {
  const { client_code, token, ledger_id, start_date, end_date } = data;

  return await getData(`report-module/ledger-statement/pdf/download`, {
    responseType: "blob",
    params: {
      client_code,
      ledger_id,
      start_date,
      end_date,
    },

    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

export async function getMultipleLedgerStatementPdfApi(
  data: GetMultipleLedgerStatementPdfType
): Promise<AxiosResponse> {
  const { token, start_date, end_date, client_code, type } = data;

  return await getData(`report-module/multiple/ledger-statement/pdf/download`, {
    responseType: "blob",
    params: {
      start_date,
      end_date,
      client_code,
      type,
    },
    headers: {
      "Content-Type": "application/json",
      "user-token": token
    }
  });
}


export async function getStockLimitApi(
  data: GetStockLimitPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, skuGroup, quantity ,date} = data;

  const finalData = {
    client_code,
    stock_group_id: skuGroup,
    date_of_invoice:date,
    quantity
  };
  return await getData(`report-module/stock-limit-report`, {
    params: finalData,
    headers: {
      "content-Type": "application/json",
      "user-token": token,
    },
  });
}


export async function downloadStockLimitApi(
  data: DownloadExcelStockLimitPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, skuGroup, quantity ,date} = data;

  return await getData(`report-module/stock-limit-report/download`, {
    params: {
      client_code,
      stock_group_id: skuGroup,
      date_of_invoice:date,
      quantity
    },
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

// Batch Summary Report 

export async function getBatchSummaryReportApi(
  data: BatchSummaryReportPayloadType
): Promise<AxiosResponse> {
  const {token, client_code, startDate, endDate, stockItemId} = data;

  const finalData = {
    client_code,
    stock_item_id: stockItemId,
    start_date: startDate,
    end_date: endDate,
  };
  return await getData(`report-module/batch/summary`, {
    params: finalData,
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

// Batch Summary Report Download

export async function downloadBatchSummaryReportApi(
  data: DownloadBatchSummaryReportsType
) : Promise<AxiosResponse> {
  const {token, client_code, start_date, end_date, stockItemId } = data;

  return await getData(`report-module/batch/summary/download`, {
    params: {
      client_code,
      start_date,
      end_date,
      stock_item_id: stockItemId,
    },
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

// Batch Voucher Report 

export async function getBatchVoucherReportApi(
  data: BatchVoucherReportPayloadType
): Promise<AxiosResponse> {
  const { token, client_code, startDate, endDate, stockItemId, batchId } = data;

  const finalData = {
    client_code,
    stock_item_id: stockItemId,
    start_date: startDate,
    end_date: endDate,
    batch_id: batchId,
  };
  return await getData(`report-module/batch/voucher`, {
    params: finalData,
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

// Download Batch Voucher Report

export async function downloadBatchVoucherReportApi(
  data: DownloadBatchVoucherReportType
): Promise<AxiosResponse>{
  const {token, client_code, start_date, end_date, stockItemId, batchId} = data;

  return await getData(`report-module/batch/voucher/download`, {
    params: {
      client_code,
      start_date,
      end_date,
      stock_item_id: stockItemId,
      batch_id: batchId,
    },
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

// Monthly Ledger Summary

export async function getMonthlyLedgerSummaryApi(
  data: GetMonthlyLedgerSummaryType
): Promise<AxiosResponse> {
  const { token, client_code, startDate, endDate, ledgerId, branchId } = data;

  const finalData = {
    client_code,
    ledger_id: ledgerId,
    start_date: startDate,
    end_date: endDate,
    branch_id: (branchId && branchId),
  };
  return await getData(`invoice-generation/monthly/ledger/summary`, {
    params: finalData,
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}

// Monthly Ledger Summary Download

export async function downloadMonthlyLedgerSummaryApi(
  data: DownloadMonthlyLedgerSummaryType
): Promise<AxiosResponse> {
  const {startDate, endDate, ledgerId, token, client_code, branchId} = data;

  const finalData = {
    client_code,
    start_date: startDate,
    end_date: endDate,
    branch_id: branchId,
    ledger_id: ledgerId,
  };
  return await getData(`invoice-generation/monthly/ledger/summary/download`, {
    params: finalData,
    responseType: "blob",
    headers: {
      "Content-Type": "application/json",
      "user-token": token,
    },
  });
}